import polfBall from '@/assets/polf_logo_ball.png'

type Size = 'sm' | 'md' | 'lg' | 'xl'

const SIZE_CLASS: Record<Size, string> = {
  sm: 'w-7 h-7',
  md: 'w-9 h-9',
  lg: 'w-12 h-12',
  xl: 'w-16 h-16',
}

type Props = {
  size?: Size
  className?: string
}

// POLF brand mark — the round ball logo used in every app chrome
// (mobile topbar, desktop sidebar, public registration shell). Replaces
// the earlier red-P-on-square placeholder for visual consistency with
// player + projector + legacy.
const BrandMark = ({ size = 'md', className = '' }: Props) => (
  <img
    src={polfBall}
    alt="POLF"
    className={`${SIZE_CLASS[size]} object-contain flex-shrink-0 ${className}`}
  />
)

export default BrandMark
